import React from 'react';

import Grid from '@mui/material/Grid2';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

const StyledDivider = styled(Divider)(({ theme }) => ({
  background: theme.palette.grey[200],
  margin: theme.spacing(2, 0),
}));

const CheckDataGrid = styled(Grid)(({ theme }) => ({
  minHeight: theme.spacing(7),
  minWidth: 'min-content',
}));

interface CheckTimeDataProps {
  checkinContent: string | (() => React.ReactNode) | React.ReactNode;
  checkoutContent: string | (() => React.ReactNode) | React.ReactNode;
  divider?: React.ReactNode;
}

export default function CheckTimeData({
  divider,
  checkinContent,
  checkoutContent,
}: CheckTimeDataProps) {
  return (
    <Grid container spacing={0} direction="column">
      <CheckDataGrid justifyContent="center" alignContent="center">
        {typeof checkinContent === 'function'
          ? checkinContent()
          : checkinContent}
      </CheckDataGrid>

      {divider}
      {!divider && <StyledDivider />}

      <CheckDataGrid justifyContent="center" alignContent="center">
        {typeof checkoutContent === 'function'
          ? checkoutContent()
          : checkoutContent}
      </CheckDataGrid>
    </Grid>
  );
}
